// src/components/sections/OurPartners.jsx
import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useTheme } from '../../hooks/useTheme';
import styles from './OurPartners.styles';

import sallaLogo from '../../assets/sallaLogo.png';
import WooCommerce from '../../assets/WooCommerce.png';
import rasd from '../../assets/rasd.png';
import shoifylogo from '../../assets/shoifylogo.png';
import Zid from '../../assets/Zid.png';


const OurPartners = () => {
  const { isDarkMode } = useTheme();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: [0.04, 0.62, 0.23, 0.98] }
    }
  };

  // Partner logos with logoStyle property to handle dark mode visibility
  const partners = [
    {
      name: "Salla",
      logo: sallaLogo, 
      color: "#006064", // Fallback color
      logoStyle: isDarkMode ? styles.darkModeLogo : {}
    },
    {
      name: "shoify",
      logo: shoifylogo,
      color: "#96bf48",
      logoStyle: isDarkMode ? styles.darkModeLogo : {}
    },
    {
      name: "WooCommerce",
      logo: WooCommerce,
      color: "#7f54b3",
      logoStyle: isDarkMode ? styles.darkModeLogo : {}
    },
    {
      name: "Zid",
      logo: Zid,
      color: "#7a5eea",
      logoStyle: isDarkMode ? styles.darkModeLogo : {}
    },
    {
      name: "rasd",
      logo: rasd,
      color: "#7a5eea",
      logoStyle: isDarkMode ? styles.darkModeLogo : {}
    }
  ];

  return (
    <section 
      ref={ref}
      style={styles.section(isDarkMode)}
      id="infrastructure"
    >
      <div style={styles.container}>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          <motion.div 
            variants={itemVariants}
            style={styles.header}
          >
            <h2 style={styles.heading(isDarkMode)}>
              Our Partners
            </h2>
          </motion.div>

          <motion.div 
            variants={itemVariants}
            style={styles.partnersRow}
          >
            {partners.map((partner, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                custom={index}
                whileHover={{ 
                  y: -10, 
                  scale: 1.05,
                  transition: { duration: 0.2 }
                }}
                style={styles.partnerContainer}
              >
                <motion.div
                  animate={{ 
                    boxShadow: [
                      '0 0 0 rgba(0,0,0,0.1)',
                      '0 10px 20px rgba(0,0,0,0.15)',
                      '0 0 0 rgba(0,0,0,0.1)'
                    ]
                  }}
                  transition={{
                    duration: 4,
                    repeat: Infinity,
                    repeatType: "reverse",
                    ease: "easeInOut",
                    delay: index * 0.5
                  }}
                  style={styles.logoWrapper(isDarkMode)}
                >
                  <img 
                    src={partner.logo} 
                    alt={`${partner.name} logo`} 
                    style={{...styles.logoImage, ...partner.logoStyle}}
                    onError={(e) => {
                      // Fallback for missing images
                      e.target.style.display = 'none';
                      e.target.parentNode.innerHTML = `<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-size: 2.5rem; font-weight: bold; color: ${partner.color};">${partner.name.charAt(0)}</div>`;
                    }}
                  />
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default OurPartners;